var moment = require('moment');
var momentformat = require("moment-duration-format");

module.exports = {
  install: function (Vue, options) {
    Vue.filter('duration', function() {
      var formatted;

      function duration() {
        var args = Array.prototype.slice.call(arguments);
        var input = args.shift();

        formatted = moment.duration(input, "seconds").format("mm:ss", { trim: false });
      }

      duration.apply(duration, arguments);
      return formatted;
    });
  },
};



// WEBPACK FOOTER //
// ./src/filters/duration.filter.js